import gql from 'graphql-tag'

export const GET_FOLDERS = gql`
  query GetFolders($limit: Int = 20) {
    folders(limit: $limit) {
      id
      name
      public
    }
  }
`

export const CREATE_FOLDER = gql`
  mutation CreateFolder($name: String!, $public: Boolean = false) {
    createFolder(name: $name, public: $public) {
      id
      name
      public
    }
  }
`

export const EDIT_FOLDER = gql`
  mutation EditFolder($id: Int!, $name: String!, $public: Boolean = false) {
    updateFolder(folderId: $id, name: $name, public: $public) {
      id
      name
      public
    }
  }
`

export const DELETE_FOLDER = gql`
  mutation DeleteFolder($id: Int!) {
    deleteFolder(folderId: $id)
  }
`
